import { createProvider } from '@nvision/services/data-provider';

import type { NewContract } from '../../models';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizeCreateContract } from './normalize';

export const createContract = createProvider(
  (values: NewContract, options: { signal?: AbortController['signal'] } = {}) =>
    api.createContract(normalizeCreateContract(values), options),
)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Create contract is aborted');
    } else {
      logger.error(`Create contract was failed: ${error}`);
    }
    throw error;
  });
